import { Box, IconButton, SxProps } from '@mui/material';
import { ArrowBack as ArrowBackIcon, CloseRounded } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { redirectTo } from 'app/route/route';
import { useAdvisorProfileTheme } from '../AdvisorProfile/AdvisorProfileThemeProvider';
import { isNativeApp } from 'utils/DeviceInfo/DeviceInfo';
import { AuthenticatedUser, AuthenticatedUserContext } from 'hooks/hooks';
import { useContext } from 'react';
import clsx from 'clsx';
import styles from './Backbutton.module.css';
export function Backbutton(props: {
  sx?: SxProps;
  target?: string;
  cardId: string;
  className?: string;
}) {
  const navigate = useNavigate();
  const AuthenticatedUser = useContext<AuthenticatedUser>(
    AuthenticatedUserContext,
  );
  const { mainColor } = useAdvisorProfileTheme();
  const isNative = isNativeApp();

  const className = clsx(styles.BackButton, props.className);
  console.log('Backbutton - className: ', className);
  if (
    AuthenticatedUser.authenticated &&
    AuthenticatedUser.isAdviserProfileOwner(props.cardId)
  ) {
    return (
      <Box className={className}>
        <IconButton
          className={className}
          sx={{
            color: mainColor,
            '&:hover': {
              color: mainColor,
            },
            ...props.sx,
          }}
          onClick={
            props.target
              ? () => {
                  redirectTo(navigate, props.target);
                }
              : () => {
                  window.history.back();
                }
          }
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>
    );
  } else if (isNative) {
    // console.log('Rendering close button for native app');
    return (
      <IconButton
        className={props.className}
        sx={{
          opacity: 0.5,
          color: mainColor,
          '&:hover': {
            opacity: 0.5,
            color: mainColor,
          },
          ...props.sx,
        }}
        onClick={
          props.target
            ? () => {
                redirectTo(navigate, props.target);
              }
            : () => {
                window.history.back();
              }
        }
      >
        <CloseRounded />
      </IconButton>
    );
  }
  // console.log('Rendering empty back for web');
  return <Box className={className}></Box>;
}

export default Backbutton;
